module.exports = __webpack_public_path__ + "img/goals-icon.3e0876c3.svg";